<div *ngIf="control && errorMessage !== null" id="control-errors" [class]="'text-danger '+ class " [@fadeInOut]>{{('common.errors.' + errorMessage) | translate}}</div>
